export default __webpack_public_path__ + "static/media/Emblem_Business_Leader_of_the_Year_2023.df35743c.png";